import { SET_STOP_STREAM_CONFIRMATION } from 'actions/Types';

export default stream => dispatch => {
  const action = {
    type: SET_STOP_STREAM_CONFIRMATION,
    payload: stream
  };

  dispatch(action);
};
